module.exports = __webpack_public_path__ + "img/document.d6cbacab.svg";